var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "69",
        height: "69",
        viewBox: "0 0 69 69",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M58.6654 10.0266C52.212 3.55781 43.6179 0 34.4846 0C15.6328 0 0.292634 15.3402 0.292634 34.192C0.292634 40.2141 1.86362 46.0975 4.85156 51.2879L0 69L18.1279 64.2408C23.1181 66.967 28.7397 68.3993 34.4692 68.3993H34.4846C53.321 68.3993 69 53.0592 69 34.2074C69 25.0741 65.1187 16.4953 58.6654 10.0266ZM34.4846 62.6391C29.3712 62.6391 24.3656 61.2683 20.0069 58.6808L18.975 58.0647L8.22455 60.8833L11.0893 50.3946L10.4116 49.3165C7.56228 44.7884 6.0683 39.5672 6.0683 34.192C6.0683 18.5283 18.821 5.77567 34.5 5.77567C42.0931 5.77567 49.2241 8.73281 54.5839 14.108C59.9437 19.4833 63.2397 26.6143 63.2243 34.2074C63.2243 49.8864 50.1482 62.6391 34.4846 62.6391Z",
          fill: _vm.color,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M17.4091 24.7273L23.4659 43.0455H23.7045L29.75 24.7273H34.3864L26.1818 48H20.9773L12.7841 24.7273H17.4091ZM37.2244 48V44.9545L45.304 37.0341C46.0767 36.2538 46.7206 35.5606 47.2358 34.9545C47.7509 34.3485 48.1373 33.7614 48.3949 33.1932C48.6525 32.625 48.7812 32.0189 48.7812 31.375C48.7812 30.6402 48.6146 30.0114 48.2812 29.4886C47.9479 28.9583 47.4896 28.5492 46.9062 28.2614C46.3229 27.9735 45.66 27.8295 44.9176 27.8295C44.1525 27.8295 43.482 27.9886 42.9062 28.3068C42.3305 28.6174 41.8835 29.0606 41.5653 29.6364C41.2547 30.2121 41.0994 30.8977 41.0994 31.6932H37.0881C37.0881 30.2159 37.4252 28.9318 38.0994 27.8409C38.7737 26.75 39.7017 25.9053 40.8835 25.3068C42.0729 24.7083 43.4366 24.4091 44.9744 24.4091C46.535 24.4091 47.9063 24.7008 49.0881 25.2841C50.2699 25.8674 51.1866 26.6667 51.8381 27.6818C52.4972 28.697 52.8267 29.8561 52.8267 31.1591C52.8267 32.0303 52.66 32.8864 52.3267 33.7273C51.9934 34.5682 51.4063 35.5 50.5653 36.5227C49.732 37.5455 48.5616 38.7841 47.054 40.2386L43.0426 44.3182V44.4773H53.179V48H37.2244Z",
          fill: _vm.color,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }